/**
 * Variantes del asesor, cada una en su enlace:
 *
 *   /             foto   el rostro y la voz del Dr. (version principal)
 *   /generico     orbe   una esfera animada y una voz generica
 *   /caricatura   dibujo un asesor ilustrado (no se parece a nadie) y la voz generica
 *
 * Las dos genericas no muestran el rostro del Dr. ni usan su voz.
 */
const path = window.location.pathname;
const query = new URLSearchParams(window.location.search);

export type Variant = 'foto' | 'orbe' | 'caricatura';

export const VARIANT: Variant =
  /^\/caricatura(\/|$)/.test(path) || query.has('caricatura')
    ? 'caricatura'
    : /^\/generico(\/|$)/.test(path) || query.has('generico')
      ? 'orbe'
      : 'foto';

/** Sin el rostro ni la voz del Dr. */
export const GENERIC = VARIANT !== 'foto';

/** Prefijo de las rutas propias (enlaces /c/<token>, volver al inicio). */
export const BASE_PATH =
  VARIANT === 'orbe' && path.startsWith('/generico')
    ? '/generico'
    : VARIANT === 'caricatura' && path.startsWith('/caricatura')
      ? '/caricatura'
      : '';
